import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthUserStoreService } from '@core/services/store/auth-user-store.service';
import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE, OwlDateTimeIntl, OwlDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { LanguageCode, TranslateModule, TranslateService, UtilDate } from '@interticket/core';
import { OwlDateTimeToLabelSelectOverrideDirective } from '../form/modules/date-time-picker/components/ui-kit-date-time-menu-picker/owl-date-time-to-label-select-override.directive';
import { DateTimeIntl, owlDateTimeFormatFactory } from './configs/date-time-picker-localization';
import { LuxonDateTimeAdapter } from './configs/date-time-picker-luxon-adapter';
import { UiKitDateTimePickerInlineDirective } from './directives/ui-kit-date-time-picker-inline.directive';
import { IUiKitDateTimePickerModuleConfig, UI_KIT_DATE_TIME_PICKER_MODULE_CONFIG } from './interfaces/ui-kit-date-time-picker-module-config.interface';

@NgModule({
  imports: [
    CommonModule,
    OwlDateTimeModule,
    TranslateModule,
  ],
  declarations: [
    UiKitDateTimePickerInlineDirective,
    OwlDateTimeToLabelSelectOverrideDirective,
  ],
  exports: [
    OwlDateTimeModule,
    UiKitDateTimePickerInlineDirective,
    OwlDateTimeToLabelSelectOverrideDirective,
  ],
  providers: [
    {
      provide: UI_KIT_DATE_TIME_PICKER_MODULE_CONFIG,
      useFactory: (translate: TranslateService, authUserStore: AuthUserStoreService): IUiKitDateTimePickerModuleConfig => ({
        locale: translate.currentLang || LanguageCode.EN,
        format: UtilDate.getDateTimeFormats(translate.currentLang),
        timeZone: authUserStore.defaultTimezone,
      }),
      deps: [TranslateService, AuthUserStoreService],
    },
    {
      provide: OWL_DATE_TIME_LOCALE,
      useFactory: (translate: TranslateService) => translate.currentLang,
      deps: [TranslateService],
    },
    {
      provide: OWL_DATE_TIME_FORMATS,
      useFactory: owlDateTimeFormatFactory,
      deps: [UI_KIT_DATE_TIME_PICKER_MODULE_CONFIG],
    },
    {
      provide: DateTimeAdapter,
      useClass: LuxonDateTimeAdapter,
      deps: [UI_KIT_DATE_TIME_PICKER_MODULE_CONFIG],
    },
    {
      provide: OwlDateTimeIntl,
      useClass: DateTimeIntl,
    },
  ],
})
export class UiKitDateTimeModule { }
